module.exports = __webpack_public_path__ + "static/bar1-44676e3665c625bcb464bb9041d06329.jpg";